<div class="flex flex-col md:flex-row w-full">

    <div class="flex flex-col w-full mb-4 md:m-4">
        <fuse-card class="flex flex-col p-4">
            <div class="text-2xl text-black font-extrabold">
                Order summary
            </div>

            <hr class="my-5">

            <div *ngFor="let o of order" class="flex flex-row justify-between items-center py-4">


                <div class="md:flex flex-col hidden w-1/2">

                    <img class="w-10 h-auto md:h-auto md:w-12"
                        *ngIf="!o.IsStockManaged"
                        [src]="getProviderLogo(o.PackageSupplierOrganisationEntityID)"
                        alt="ProviderLogoFile" loading="lazy">

                </div>
                <div class="flex flex-col w-full">

                    <div class="flex flex-row font-extrabold items-start justify-start">
                        {{o.OfferableName}}
                    </div>

                    <div class="flex flex-row text-black text-sm items-start justify-start">
                        {{o.EntityLinkedOfferableDescription}}
                    </div>


                    <!--
                     ### REMOVING FOR NOW SO IT DOES NOT SHOW FOR PACKAGES THAT HAVE NO FIXED SPEEDS ###
                    -->
                    <!-- <div *ngIf="o.MbpsDownload && o.MbpsUpload && o.OfferableSubTypeName?.toLowerCase().includes('fibre')" class="flex flex-row justify-center items-center pt-4">
                        <div class="flex flex-col md:flex-row justify-center items-center mr-4">
                            <div class="mr-2">
                                <mat-icon svgIcon="heroicons_solid:arrow-down-circle" [color]="'primary'"></mat-icon>
                            </div>
                            <div class="flex flex-col sm:text-center">
                                <div class="font-extrabold text-base md:text-lg">
                                    Upload
                                </div>
                                <div class="text-md">
                                    {{o.MbpsUpload}}Mbps
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col justify-center items-center md:flex-row">
                            <div class="mr-2">
                                <mat-icon svgIcon="heroicons_solid:arrow-down-circle" [color]="'primary'"></mat-icon>
                            </div>
                            <div class="flex flex-col sm:text-center">
                                <div class="font-extrabold text-base md:text-lg">
                                    Download
                                </div>
                                <div class="text-md">
                                    {{o.MbpsDownload}}Mbps
                                </div>
                            </div>
                        </div>
                    </div> -->

                </div>

                <div class="flex flex-col text-primary font-extrabold w-full items-end justify-end">
                    {{o.Billing_TotalIncl | currency:'R'}}
                </div>

            </div>

            <div>
                <hr class="my-5">
                <div class="text-black font-bold">Add-ons</div>

                <div *ngFor="let a of addOns" class="flex flex-row justify-between items-center py-4">


                    <div class="flex flex-col">

                        <img class="w-10 h-auto md:h-auto md:w-12"
                            [src]="a.OfferableThumbnailFileID ? getThumbnail(a.OfferableEntityID) : getProviderLogo(a.PackageSupplierOrganisationEntityID)"
                            alt="ProviderLogoFile" loading="lazy">

                    </div>
                    <div class="flex flex-col">

                        <div class="flex flex-row font-extrabold">
                            {{a.OfferableName}}
                        </div>

                        <div class="flex flex-row text-black text-sm">
                            {{a.EntityLinkedOfferableDescription}}
                        </div>

                    <!--
                     ### REMOVING FOR NOW SO IT DOES NOT SHOW FOR PACKAGES THAT HAVE NO FIXED SPEEDS ###
                    -->
                    <!-- 
                        <div *ngIf="a.MbpsDownload" class="flex flex-row justify-center items-center pt-4">
                            <div class="flex flex-col md:flex-row justify-center items-center mr-4">
                                <div class="mr-2">
                                    <mat-icon svgIcon="heroicons_solid:arrow-down-circle"
                                        [color]="'primary'"></mat-icon>
                                </div>
                                <div class="flex flex-col sm:text-center">
                                    <div class="font-extrabold text-base md:text-lg">
                                        Upload
                                    </div>
                                    <div class="text-md">
                                        {{a.MbpsUpload}}Mbps
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-col justify-center items-center md:flex-row">
                                <div class="mr-2">
                                    <mat-icon svgIcon="heroicons_solid:arrow-down-circle"
                                        [color]="'primary'"></mat-icon>
                                </div>
                                <div class="flex flex-col sm:text-center">
                                    <div class="font-extrabold text-base md:text-lg">
                                        Download
                                    </div>
                                    <div class="text-md">
                                        {{a.MbpsDownload}}Mbps
                                    </div>
                                </div>
                            </div>
                        </div> -->

                    </div>

                    <div class="flex flex-col text-primary font-extrabold">
                        {{a.Billing_TotalIncl | currency:'R'}}
                    </div>

                </div>


            </div>

            <hr class="my-5">

            <div class="flex flex-col w-full">

                <div class="pb-2 flex flex-row">
                    <div class="font-bold text-primary w-1/2 md:w-2/3 flex flex-col justify-start px-1">
                        Total Once-off payment due:
                    </div>
                    <div class="text-black w-1/2 md:w-1/3 flex flex-col justify-start px-1">
                        {{upFrontAmount | currency:'R'}} - incl
                    </div>
                </div>

                <div class="pb-2 flex flex-row">
                    <div class="text-black w-1/2 md:w-2/3 flex flex-col justify-start px-1 font-bold">
                        VAT:
                    </div>
                    <div class="text-black w-1/2 md:w-1/3 flex flex-col justify-start px-1">
                        {{upFrontAmount * (15 / 100) | currency:'R'}}
                    </div>
                </div>

            </div>

            <hr class="my-5">

            <div class="flex flex-col">
                <div class="pb-2 flex flex-row">
                    <div class="font-bold text-primary w-1/2 md:w-2/3 flex flex-col justify-start px-1">
                        Total Monthly:
                    </div>
                    <div class="text-black w-1/2 md:w-1/3 flex flex-col justify-start px-1">
                        {{monthlyAmount | currency:'R' }} - incl
                    </div>
                </div>

                <div class="pb-2 flex flex-row">
                    <div class="text-black w-1/2 md:w-2/3 flex flex-col justify-start px-1 font-bold">
                        VAT:
                    </div>
                    <div class="text-black w-1/2 md:w-1/3 flex flex-col justify-start px-1">
                        {{monthlyAmount * (15 / 100) | currency:'R'}}
                    </div>
                </div>

            </div>

        </fuse-card>
    </div>

    <div class="flex flex-col w-full md:m-4">
        <div class="mb-4">
            <fuse-card class="flex flex-col p-4">
                <div class="text-2xl text-black font-extrabold">
                    Installation{{lead?.DeliveryAddressSameAsInstallationAddress ? '/Delivery' : ''}} address
                </div>

                <hr class="my-5">

                <google-map [options]="mapOptions" width="100%" height="150px" class="map-container">
                    <map-marker [position]="center">

                    </map-marker>
                </google-map>

                <div class="text-black pt-4">
                    {{lead?.Address}}
                </div>

            </fuse-card>

        </div>
        <div *ngIf="!lead?.DeliveryAddressSameAsInstallationAddress && lead?.DeliveryTown">
            <fuse-card class="flex flex-col p-4">
                <div class="text-2xl text-black font-extrabold">
                    Delivery address
                </div>

                <hr class="my-5">

                <div class="text-black pt-4" *ngIf="lead?.DeliveryAddressPropertyType == 'FreeStanding'">
                    {{lead?.DeliveryStreetNumber}}, {{lead?.DeliveryStreetName}}, {{lead?.DeliveryCity}},
                    {{lead?.PostalCode}}
                </div>

                <div class="text-black pt-4" *ngIf="lead?.DeliveryAddressPropertyType == 'Apartment'">
                    {{lead?.DeliveryUnitNumber}}, {{lead?.DeliveryComplexName}}, {{lead?.DeliveryFloorNumber}},
                    {{lead?.DeliveryBlockName}}, {{lead?.DeliverySubComplexName}}
                </div>

                <div class="text-black pt-4" *ngIf="lead?.DeliveryAddressPropertyType == 'Estate'">
                    {{lead?.DeliveryUnitNumber}}, {{lead?.DeliveryComplexStreetName}}, {{lead?.DeliveryComplexName}},
                    {{lead?.DeliverySubComplexName}}
                </div>

                <div class="text-black pt-4" *ngIf="lead?.DeliveryAddressPropertyType == 'Plot'">
                    {{lead?.DeliveryErfNumber}}, {{lead?.LeadNotes}}
                </div>

            </fuse-card>

        </div>

        <app-terms 
            class="w-full" 
            (termsAndConditions)="termsCheck($event)">
        </app-terms>

    </div>

</div>